// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__3AWjt","ThumbZoom":"ChapterPlayer_ThumbZoom__2QAWz"};